export function fixDoubleEscapedStringResponse(value: any): typeof value {
    if (typeof value !== 'string' || !value) {
        return value;
    }
    if (value[0] === '"') {
        value = value.substring(1);
    }
    if (value[value.length-1] === '"') {
        value = value.substring(0, value.length-1);
    }
    if (value[0] === "'") {
        value = value.substring(1);
    }
    if (value[value.length-1] === "'") {
        value = value.substring(0, value.length-1);
    }
    return value;
}